<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="card-title">
                <h5 class="float-left">Units</h5>
                <b-button
                  variant="primary"
                  class="btn btn-label btn-primary float-right"
                  v-b-modal.modal_addUnit
                  ><i class="bx bx-plus label-icon"></i>Add Unit</b-button
                >
                <!-- Add Unit Modal -->
                <b-modal
                  id="modal_addUnit"
                  title="Add Unit"
                  title-class="font-18"
                  ok-title="Add Unit"
                  @ok="addUnit"
                  @close="clearModal"
                  @cancel="clearModal"
                >
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Unit Name</label>
                      <b-form-input
                        placeholder="Unit Name..."
                        v-model="unitName"
                        :state="
                          submitErrorName === null
                            ? validateEntry('name')
                            : submitErrorName
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ unitNameErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Year</label>
                      <b-form-input
                        placeholder="Year..."
                        v-model="unitYear"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Make</label>
                      <b-form-input
                        placeholder="Make..."
                        v-model="unitMake"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Model</label>
                      <b-form-input
                        placeholder="Model..."
                        v-model="unitModel"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Serial Number</label>
                      <b-form-input
                        placeholder="Serial Number..."
                        v-model="unitSerial"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Type</label>
                      <v-select
                        :options="[
                          { label: 'Heavy Truck', value: 'heavyTruck' },
                          { label: 'Trailer', value: 'trailer' },
                          { label: 'Light Truck', value: 'lightTruck' },
                          { label: 'Fixed Asset', value: 'fixedAsset' },
                          { label: 'Other', value: 'other' },
                        ]"
                        label="label"
                        v-model="unitType"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Notes</label>
                      <b-form-textarea
                        placeholder="Notes..."
                        v-model="unitNotes"
                      ></b-form-textarea>
                    </div>
                  </div>
                </div>
                <!-- <hr />
                  <div class="row mb-3">
                    <div class="col-12">
                      <h5>Unit Options</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <div class="form-group">
                        <label id="lbl_orgUnit">
                          Organizational Unit
                          <i class="bx bxs-help-circle"></i>
                        </label>
                        <b-tooltip target="lbl_orgUnit"
                          >Allows grouping of units for searching and
                          reporting.</b-tooltip
                        >
                        <v-select
                          :options="[
                            { label: 'Company', value: 'company' },
                            { label: 'Contractor', value: 'contractor' },
                            { label: 'Third Party', value: 'thirdParty' },
                          ]"
                          label="label"
                          v-model="unitOrgUnit"
                        ></v-select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="">Show in Work Orders Page</label>
                        <div>
                          <switches
                            v-model="unitWorkOrdersEnabled"
                            type-bold="false"
                            color="primary"
                            class="ml-1 mb-0 mt-2"
                          ></switches>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label id="lbl_serviceSchedule">
                          Show in Service/Inspection Schedule
                          <i class="bx bxs-help-circle"></i>
                        </label>
                        <b-tooltip target="lbl_serviceSchedule"
                          >The service/inspection schedule allows maintenance
                          users to input the recurring service/inspection
                          schedule of the unit. The hours/kms of the unit can be
                          manually entered into the service/inspection schedule
                          page, or can be automatically updated from the values
                          entered into the unit's associated work orders. When
                          the service/inspection is due, an email notification
                          will be sent out, or can be viewed from the
                          service/inspection page.</b-tooltip
                        >
                        <div>
                          <switches
                            v-model="unitScheduleEnabled"
                            type-bold="false"
                            color="primary"
                            class="ml-1 mb-0 mt-2"
                          ></switches>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </b-modal>
                <!-- /Add Unit Modal -->
                <!--  -->
                <!--  -->
                <!-- Edit Unit Modal -->

                <b-modal
                  id="modal_editUnit"
                  title="Edit Unit"
                  title-class="font-18"
                  ok-title="Edit Unit"
                  @ok="editUnit"
                  @close="clearModal"
                  @cancel="clearModal"
                >
                <div class="row mb-3">
                  <div class="col-12">
                    <h5>Unit Information</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Unit Name</label>
                      <b-form-input
                        placeholder="Unit Name..."
                        v-model="unitName"
                        :state="
                          submitErrorName === null
                            ? validateEntry('name')
                            : submitErrorName
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ unitNameErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Year</label>
                      <b-form-input
                        placeholder="Year..."
                        v-model="unitYear"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Make</label>
                      <b-form-input
                        placeholder="Make..."
                        v-model="unitMake"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Model</label>
                      <b-form-input
                        placeholder="Model..."
                        v-model="unitModel"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Serial Number</label>
                      <b-form-input
                        placeholder="Serial Number..."
                        v-model="unitSerial"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Type</label>
                      <v-select
                        :options="[
                          { label: 'Heavy Truck', value: 'heavyTruck' },
                          { label: 'Trailer', value: 'trailer' },
                          { label: 'Light Truck', value: 'lightTruck' },
                          { label: 'Fixed Asset', value: 'fixedAsset' },
                          { label: 'Other', value: 'other' },
                        ]"
                        v-model="unitType"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Notes</label>
                      <b-form-textarea
                        placeholder="Notes..."
                        v-model="unitNotes"
                      ></b-form-textarea>
                    </div>
                  </div>
                </div>
                <!-- <hr />
                <div class="row mb-3">
                  <div class="col-12">
                    <h5>Unit Options</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label id="lbl_orgUnit">
                        Organizational Unit
                        <i class="bx bxs-help-circle"></i>
                      </label>
                      <b-tooltip target="lbl_orgUnit"
                        >Allows grouping of units for searching and
                        reporting.</b-tooltip
                      >
                      <v-select
                        :options="[
                          { label: 'Company', value: 'company' },
                          { label: 'Contractor', value: 'contractor' },
                          { label: 'Third Party', value: 'thirdParty' },
                        ]"
                        label="label"
                        v-model="unitOrgUnit"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label class="">Show in Work Orders Page</label>
                      <div>
                        <switches
                          v-model="unitWorkOrdersEnabled"
                          type-bold="false"
                          color="primary"
                          class="ml-1 mb-0 mt-2"
                        ></switches>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label id="lbl_serviceSchedule">
                        Show in Service/Inspection Schedule
                        <i class="bx bxs-help-circle"></i>
                      </label>
                      <b-tooltip target="lbl_serviceSchedule"
                        >The service/inspection schedule allows maintenance
                        users to input the recurring service/inspection
                        schedule of the unit. The hours/kms of the unit can be
                        manually entered into the service/inspection schedule
                        page, or can be automatically updated from the values
                        entered into the unit's associated work orders. When
                        the service/inspection is due, an email notification
                        will be sent out, or can be viewed from the
                        service/inspection page.</b-tooltip
                      >
                      <div>
                        <switches
                          v-model="unitScheduleEnabled"
                          type-bold="false"
                          color="primary"
                          class="ml-1 mb-0 mt-2"
                        ></switches>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row"></div> -->
              </b-modal>
                <!-- /Edit User Modal -->
                <!--  -->
                <!--  -->
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-12 col-md-12">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        v-model="unitsPerPage"
                        size="sm"
                        :options="unitsPageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>

                <!-- Search -->
                <div class="col-sm-12 col-md-6 d-flex">
                  <div class="form-group d-flex mr-3">
                    <label class="pt-1">Show deactivated units</label>
                    <div>
                      <switches
                        v-model="showDeactivatedUnits"
                        type-bold="false"
                        color="primary"
                        class="ml-1 mb-0 mt-2"
                      ></switches>
                    </div>
                  </div>
                  <div
                    id="units-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="unitsFilter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="filteredTableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="unitsPerPage"
                  :current-page="unitsCurrentPage"
                  :sort-by.sync="unitsSortBy"
                  :sort-desc.sync="unitsSortDesc"
                  :filter="unitsFilter"
                  :filter-included-fields="unitsFilterOn"
                >
                  <template v-slot:cell(edit)="data">
                    <b-dropdown variant="primary" size="sm">
                      <template v-slot:button-content>
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-b-modal.modal_editUnit
                        @click="populateEditUnit(data.item)"
                        ><i class="bx bx-pencil mr-2 tableIcons"></i
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item v-if="!data.item.dateDeactivated" @click="deleteUnit(data.item.edit)"
                        ><i class="bx bx-trash mr-2 tableIcons"></i> 
                        Deactivate
                      </b-dropdown-item>
                      <b-dropdown-item v-else @click="reactivateUnit(data.item.edit)"
                        ><i class="bx bx-check-circle mr-2 tableIcons"></i>
                        Activate
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <template v-slot:cell(unitType)="data">
                    {{ data.value.label }}
                  </template>
                  <template v-slot:cell(unitOrgUnit)="data">
                    {{ data.value.label }}
                  </template>
                  <template v-slot:cell(unitWorkOrdersEnabled)="data">
                    <b-badge :variant="data.value ? 'success' : 'danger'">{{
                      data.value ? 'Yes' : 'No'
                    }}</b-badge>
                  </template>
                  <template v-slot:cell(unitScheduleEnabled)="data">
                    <b-badge :variant="data.value ? 'success' : 'danger'">{{
                      data.value ? 'Yes' : 'No'
                    }}</b-badge>
                  </template>
                  <template v-slot:cell(dateDeactivated)="data">
                    <b-badge :variant="data.value ? 'danger' : 'success'">{{
                      data.value ? 'No' : 'Yes'
                    }}</b-badge>
                  </template>
                </b-table>
              </div>
              <!-- /Table -->
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="unitsCurrentPage"
                        :total-rows="unitsTotalRows"
                        :per-page="unitsPerPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!--/Row-->
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
  </div>
</template>
<script>
import { firestore } from 'firebase';
import Swal from 'sweetalert2';
import Switches from 'vue-switches';
import lodash from 'lodash';

export default {
  components: {
    Switches,
  },
  data() {
    return {
      unitName: null,
      unitYear: null,
      unitMake: null,
      unitModel: null,
      unitSerial: null,
      unitType: null,
      unitNotes: null,
      unitWorkOrdersEnabled: false,
      unitScheduleEnabled: false,
      unitOrgUnit: null,
      unitNameValid: false,
      editID: null,
      submitErrorName: null,
      unitNameErrorMessage: null,

      tableData: [],
      fields: [
        { key: 'edit' },
        { key: 'name', label: 'Unit Name', sortable: true },
        { key: 'unitYear', label: 'Year', sortable: true },
        { key: 'unitMake', label: 'Make', sortable: true },
        { key: 'unitModel', label: 'Model', sortable: true },
        { key: 'unitSerial', label: 'Serial #', sortable: true },
        { key: 'unitType', label: 'Unit Type', sortable: true },
        { key: 'unitNotes', label: 'Notes', sortable: true },
        { key: 'dateDeactivated', label: 'Active', sortable: true },
        // { key: 'unitOrgUnit', label: 'Org. Unit', sortable: true },
        // { key: 'unitWorkOrdersEnabled', label: 'WOs Enabled', sortable: true },
        // {
        //   key: 'unitScheduleEnabled',
        //   label: 'Service/Inspection Enabled',
        //   sortable: true,
        // },
        // { key: 'defaultRate', label: 'Rate', sortable: true },
      ],
      unitsSortBy: 'name',
      unitsSortDesc: false,
      unitsPerPage: 10,
      unitsTotalRows: 1,
      unitsCurrentPage: 1,
      unitsPageOptions: [10, 25, 50, 100],
      unitsFilter: null,
      unitsFilterOn: [],
      currentUserData: [],
      showDeactivatedUnits: false,
      unitDateDeactivated: null,
    };
  },
  methods: {
    addUnit(bvModalEvt) {
      if (this.unitNameValid) {
        try {
          let unit = {
            name: this.unitName.trim(),
            unitYear: this.unitYear != null ? this.unitYear.trim() : null,
            unitMake: this.unitMake != null ? this.unitMake.trim() : null,
            unitModel: this.unitModel != null ? this.unitModel.trim() : null,
            unitSerial: this.unitSerial != null ? this.unitSerial.trim() : null,
            unitType: this.unitType ? this.unitType : null,
            unitNotes: this.unitNotes != null ? this.unitNotes.trim() : null,
            unitWorkOrdersEnabled: true,
            unitScheduleEnabled: true,
            unitOrgUnit: null,
            org: sessionStorage.org,
            dateDeactivated: null,
          };
          firestore()
            .collection('units')
            .add(unit)
            .then((doc) => {
              unit['edit'] = doc.id;
              this.tableData.push(unit);
              this.clearModal();
              Swal.fire('Success!', 'Unit added successfully.', 'success');
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when adding the product.',
            'error'
          );
        }
      } else {
        this.submitErrorName = this.validateEntry('name', true);
        // this.submitErrorRate = this.validateEntry('rate', true);
        bvModalEvt.preventDefault();
      }
    },
    editUnit(bvModalEvt) {
      if (this.unitNameValid) {
        try {
          let unit = {
            name: this.unitName.trim(),
            unitYear: this.unitYear != null ? this.unitYear.trim() : null,
            unitMake: this.unitMake != null ? this.unitMake.trim() : null,
            unitModel: this.unitModel != null ? this.unitModel.trim() : null,
            unitSerial: this.unitSerial != null ? this.unitSerial.trim() : null,
            unitType: this.unitType ? this.unitType : null,
            unitNotes: this.unitNotes != null ? this.unitNotes.trim() : null,
            unitWorkOrdersEnabled: true,
            unitScheduleEnabled: true,
            unitOrgUnit: null,
            org: sessionStorage.org,
            dateDeactivated: this.unitDateDeactivated,
          };
          firestore()
            .collection('units')
            .doc(this.editID)
            .update(unit)
            .then(() => {
              unit['edit'] = this.editID;
              let index = this.tableData.findIndex(
                (data) => data.edit === this.editID
              );
              this.tableData.splice(index, 1, unit);

              this.clearModal();
              Swal.fire('Success!', 'Unit edited successfully.', 'success');
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the unit.',
            'error'
          );
        }
      } else {
        this.submitErrorName = this.validateEntry('name', true);

        bvModalEvt.preventDefault();
      }
    },
    deleteUnit(id) {
      try {
        firestore()
          .collection('units')
          .doc(id)
          .update({dateDeactivated: new Date()})
          .then(() => {
            let tableDataCopy = lodash.cloneDeep(this.tableData);
            const index = tableDataCopy.findIndex((data) => data.edit === id);
            tableDataCopy[index].dateDeactivated = new Date();
            this.tableData = tableDataCopy;
            Swal.fire('Success!', 'Unit deactivated successfully.', 'success');
          });
      } catch (error) {
        console.log('Error deactivating Unit', error);
        Swal.fire(
          'Error!',
          'An error was encountered when deactivating the unit.',
          'error'
        );
      }
    },
    reactivateUnit(id){
      try {
        firestore()
          .collection('units')
          .doc(id)
          .update({dateDeactivated: null})
          .then(() => {
            let tableDataCopy = lodash.cloneDeep(this.tableData);
            const index = tableDataCopy.findIndex((data) => data.edit === id);
            tableDataCopy[index].dateDeactivated = null;
            this.tableData = tableDataCopy;
            Swal.fire('Success!', 'Unit reactivated successfully.', 'success');
          });
      } catch (error) {
        console.log('Error reactivating Unit', error);
        Swal.fire(
          'Error!',
          'An error was encountered when reactivating the unit.',
          'error'
        );
      }
    },
    populateEditUnit(data) {
      this.unitName = data.name;
      this.unitYear = data.unitYear;
      this.unitMake = data.unitMake;
      this.unitModel = data.unitModel;
      this.unitSerial = data.unitSerial;
      this.unitType = data.unitType;
      this.unitNotes = data.unitNotes;
      this.unitWorkOrdersEnabled = data.unitWorkOrdersEnabled;
      this.unitScheduleEnabled = data.unitScheduleEnabled;
      this.unitOrgUnit = data.unitOrgUnit;
      this.editID = data.edit;
      this.unitDateDeactivated = data.dateDeactivated;
    },
    clearModal() {
      this.unitName = null;
      this.unitYear = null;
      this.unitMake = null;
      this.unitModel = null;
      this.unitSerial = null;
      this.unitType = null;
      this.unitNotes = null;
      this.unitWorkOrdersEnabled = null;
      this.unitScheduleEnabled = null;
      this.unitOrgUnit = null;
      this.unitNameValid = false;
      this.editID = null;
      this.submitErrorName = null;
      this.unitNameErrorMessage = null;
    },
    getUnits: async function () {
      try {
        firestore()
          .collection('units')
          .where('org', '==', sessionStorage.org)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let index = this.tableData.push(doc.data());
              this.tableData[index - 1]['edit'] = doc.id;
              // add the dateDeactivated field if it's not on this doc
              if(doc.data().dateDeactivated === undefined){
                this.tableData[index - 1]['dateDeactivated'] = null;
              }
            });
            this.unitsTotalRows = this.tableData.length;
          });
      } catch (error) {
        console.log('Error getting unit data', error);
      }
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_units) {
          this.unitsPerPage = this.currentUser.tablePageLengths.perPage_units;
        }
      }
    },

    validateEntry(entry, submitted) {
      if (entry === 'name') {
        if (this.unitName === null || this.unitName.trim() === '') {
          if (submitted) {
            this.unitNameValid = false;
            this.unitNameErrorMessage = 'Please enter a unit';
            return false;
          } else {
            this.unitNameValid = false;
            this.unitNameErrorMessage = 'Please enter a unit';
            return null;
          }
        } else if (
          this.tableData.findIndex((i) => i.name === this.unitName) !== -1 &&
          this.tableData[
            this.tableData.findIndex((i) => i.name === this.unitName)
          ].edit !== this.editID
        ) {
          this.unitNameValid = false;
          this.unitNameErrorMessage = `There is already a unit named ${this.unitName}`;
          return false;
        } else {
          this.unitNameValid = true;
          return true;
        }
      }
    },
  },
  mounted() {
    this.getUnits();
    this.setTableSettings();
  },
  computed:{
    filteredTableData(){
      if(this.showDeactivatedUnits){
        return this.tableData;
      } else {
        return this.tableData.filter(unit => !unit.dateDeactivated);
      }
    }
  },
  watch: {
    unitName() {
      if (this.submitErrorName !== null) {
        this.submitErrorName = null;
      }
    },
    unitsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_units){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_units;
          }
          currentUserDataCopy.tablePageLengths['perPage_units'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_units: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
};
</script>
